document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('#bcpo');
    if (!container) return;

    container.addEventListener('mouseover', function (event) {
        const target = event.target.closest('.bcpo-front-image-label');
        if (target && container.contains(target)) {
            // 避免重复添加克隆
            if (target.nextSibling?.classList?.contains('hover')) return;

            const clone = target.cloneNode(true);
            clone.classList.add('hover')
            target.parentNode.insertBefore(clone, target.nextSibling);
        }
    });

    container.addEventListener('mouseout', function (event) {
        const target = event.target.closest('.bcpo-front-image-label');
        if (target && container.contains(target)) {
            // 查找并删除紧跟其后的 .hover 元素
            const next = target.nextSibling;
            if (next && next.classList && next.classList.contains('hover')) {
                next.remove();
            }
        }
    });
});